import { forwardRef, type Ref, type SVGProps } from "react";
const IconAirQualityFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M10.67 23.52c.667 0 1.211-.437 1.31-1.07.612-3.082 4.883-8.177 11.177-6.503 1.716.456 2.782 1.08 4.087 2.949q.011.014.057.007c.064.194.206.392.482.616.662.333 1.555.24 1.886-.426l.017-.054c.263-.811.632-1.952-.192-3.755-.617-1.281-1.54-2.039-1.875-2.268-.625-.454-1.363-.793-2.056-.922a2 2 0 0 0-.35-.07c-.185-.025-.282-.037-.284-.226-.066-3.676-2.12-6.153-4.344-7.57-1.42-.827-2.843-1.27-4.931-1.225-3.42.132-5.629 2.058-6.689 3.436-.643.857-.998 1.532-1.33 2.45-.069.161-.107.3-.138.413-.065.234-.1.364-.318.365-1.454.38-2.333 1.01-3.119 1.783-.906.891-1.488 1.944-1.757 2.967-.599 2.247-.2 3.893.246 4.967.513 1.132 1.28 2.01 2.201 2.745.935.696 1.994 1.163 3.167 1.331.546.093 1.467.08 2.3.067z"
    />
    <path
      fill="currentColor"
      d="M23.695 17.019c-1.018-.441-3.91-1.155-6.858.526-1.576.919-2.538 1.998-3.32 3.517-1.04 2.155-.94 4.489-.48 5.956.146.453.332.84.592 1.225.132.168.221.255.386.389.27.183.445.25.633.306.274.058.365.057.428.057.029 0 .052 0 .083.005.318 0 1.113 0 1.768-.002l.892-.002 8.509.004c.354 0 .536-.021.824-.117.419-.17.598-.362.706-.479q.04-.043.07-.07c.38-.465.73-1.325.872-2.154.004-.042.01-.077.017-.12.017-.102.041-.245.069-.611.03-.533.053-.937-.004-1.59-.115-.99-.284-1.853-.88-2.95a1.164 1.164 0 0 0-1.58-.382c-.554.33-.825 1.065-.509 1.755.322.793.389 1.002.483 1.803.087.81-.03 1.71-.16 1.91-.134.236-.425.468-.87.493l-9.002-.002a1.2 1.2 0 0 1-.512-.083c-.387-.183-.482-.424-.518-.514q-.01-.03-.017-.034c-.267-1.223-.09-2.517.44-3.642.626-1.218 1.58-2.097 2.39-2.531 1.019-.665 3.027-.96 4.438-.401.595.145 1.319-.077 1.617-.676.335-.607.099-1.336-.507-1.587"
    />
    <path
      fill="currentColor"
      d="M25.54 20.593c.127-.316.113-.651-.185-.966-.389-.385-.778-.346-1.128-.142q-.138.107-.303.21c-.108.072-.223.147-.339.235l-3.676 2.495c-.546.353-.729.536-.929 1.011-.319 1 .017 1.678.49 2.15s1.351.682 2.158.387c.411-.198.623-.385.948-.922l2.604-3.893q.06-.094.126-.192c.077-.112.16-.232.234-.373"
    />
  </svg>
);
const ForwardRef = forwardRef(IconAirQualityFilledSVG);
ForwardRef.displayName = "IconAirQualityFilled";
export { ForwardRef as IconAirQualityFilled };
